import React from 'react'
import PropTypes from 'prop-types'
import { MuiButton, MuiIconButton, Message } from '../../../../components'
// import { MuiButton, MuiIconButton, Message, Highlighter } from '../../../../components'
import { useSearchParams } from 'react-router-dom'
import { CONST_IMG_URL } from '../../../../constants'
import { Close } from '../../../../assets/img/icons'
import { HeaderWrapper, ButtonWrapper, PageHeading, SubmitOverlay } from './style'

const Header = ({ data, loading, mode, onSave, onCancel, onEdit, onProcess, onClose, isPageId, messages }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const closePopUp = () => {
    const param = searchParams.get('id')
    if (param) {
      searchParams.delete('id')
      setSearchParams(searchParams)
      onClose(param)
    }
  }

  return (
    <HeaderWrapper>
      <PageHeading>
        {data?.AggregationItem?.ItemImageUrl && <img src={CONST_IMG_URL + data.AggregationItem.ItemImageUrl} />}
        {data?.defaultData?.AggregationItem?.ItemSource?.SourceName ? data?.defaultData?.AggregationItem?.ItemSource?.SourceName : ''}
      </PageHeading>
      <ButtonWrapper>
        <Message type={messages?.type}>{messages?.msg || ''} {messages?.error && <span>{messages?.error || ''}</span>}</Message>
        {/* <Highlighter type='add' /> */}
        {
          mode === 'none'
            ? <>
                <MuiButton disabled={loading || false} onClick={onEdit} type='submit' color='primary' variant='contained'>Edit</MuiButton>
                <MuiButton disabled={loading || false} onClick={onProcess} type='submit' color='primary' variant='contained'>Process</MuiButton>
              </>
            : <>
                <MuiButton disabled={loading || false} onClick={onSave} type='submit' color='primary' variant='contained'>Save</MuiButton>
                <MuiButton disabled={loading || false} onClick={onCancel} type='submit' color='primary' variant='contained'>Cancel</MuiButton>
              </>
        }
        {isPageId && <MuiIconButton className='closeButton' onClick={closePopUp}><Close /></MuiIconButton>}
      </ButtonWrapper>
      {loading && <SubmitOverlay />}
    </HeaderWrapper>
  )
}

Header.propTypes = {
  data: PropTypes.object,
  mode: PropTypes.string,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onEdit: PropTypes.func,
  onProcess: PropTypes.func,
  onClose: PropTypes.func,
  isPageId: PropTypes.string,
  messages: PropTypes.object,
  loading: PropTypes.bool
}

export default Header
